import { render, staticRenderFns } from "./RuleWrapper.vue?vue&type=template&id=3a55f0ba&scoped=true"
import script from "./RuleWrapper.vue?vue&type=script&lang=ts"
export * from "./RuleWrapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a55f0ba",
  null
  
)

export default component.exports